import { render, staticRenderFns } from "./orderScheme.vue?vue&type=template&id=16082a62&scoped=true"
import script from "./orderScheme.vue?vue&type=script&lang=js"
export * from "./orderScheme.vue?vue&type=script&lang=js"
import style0 from "./orderScheme.vue?vue&type=style&index=0&id=16082a62&prod&lang=stylus&scoped=true"
import style1 from "./orderScheme.vue?vue&type=style&index=1&id=16082a62&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16082a62",
  null
  
)

export default component.exports